export enum ThemeTypes {
  LIGHT_THEME = 'light-theme',
  DARK_THEME = 'dark-theme',
}
